<template>
  <div class="custom-select" v-clickoutside="hideOptions">
    <div class="select-input" @click="toggleOptions">
      <input 
        type="text" 
        :value="displayValue" 
        :placeholder="placeholder" 
        readonly
        class="fontSize4"
      />
      <span class="select-arrow" :class="{ expanded: showOptions }">▼</span>
    </div>
    <ul class="select-options" v-show="showOptions">
      <li 
        v-for="option in options" 
        :key="option.value"
        @click="selectOption(option)"
        :class="{ selected: value === option.value }"
      >
        {{ option.text }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CustomSelect',
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showOptions: false
    }
  },
  computed: {
    displayValue() {
      const selected = this.options.find(option => option.value === this.value);
      return selected ? selected.text : '';
    }
  },
  directives: {
    clickoutside: {
      bind: function (el, binding, vnode) {
        function documentHandler(e) {
          if (el.contains(e.target)) {
            return false;
          }
          if (binding.expression) {
            binding.value(e);
          }
        }
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener('click', documentHandler);
      },
      update: function () {},
      unbind: function (el, binding) {
        document.removeEventListener('click', el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      }
    }
  },
  methods: {
    toggleOptions() {
      this.showOptions = !this.showOptions;
    },
    hideOptions() {
      this.showOptions = false;
    },
    selectOption(option) {
      this.$emit('input', option.value);
      this.hideOptions();
    }
  }
}
</script>

<style scoped lang="scss">
.custom-select {
  position: relative;
  width: 100%;
}

.select-input {
  position: relative;
  cursor: pointer;
  
  input {
    width: 100%;
    height: 45px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 0 40px 0 15px;
    background: #fff;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    transition: border-color 0.3s;
    
    &:focus {
      outline: none;
      border-color: #0e4b88;
    }

    &::-webkit-input-placeholder {
      color: #999;
    }
  }
  
  .select-arrow {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #999;
    transition: transform 0.3s;
    pointer-events: none;
    
    &.expanded {
      transform: translateY(-50%) rotate(180deg);
    }
  }
}

.select-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  /* 自定义滚动条样式 */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f8f8f8;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #d0d0d0;
    border-radius: 3px;
    transition: background 0.3s ease;
    
    &:hover {
      background: #b0b0b0;
    }
  }
  
  &::-webkit-scrollbar-thumb:active {
    background: #999;
  }
  
  /* Firefox 滚动条样式 */
  scrollbar-width: thin;
  scrollbar-color: #d0d0d0 #f8f8f8;
  
  li {
    padding: 12px 15px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    transition: background-color 0.3s;
    
    &:hover {
      background: #f5f5f5;
    }
    
    &.selected {
      background: #0e4b88;
      color: #fff;
    }

    &:last-child {
      border-radius: 0 0 4px 4px;
    }
  }
}

/* 1280分辨率适配 */
@media screen and (max-width: 1280px) {
  .custom-select {
    .select-input {
      input {
        height: 42px;
        padding: 0 35px 0 12px;
        font-size: 13px;
      }
      
      .select-arrow {
        right: 12px;
        font-size: 11px;
      }
    }
    
    .select-options {
      max-height: 180px;
      
      li {
        padding: 10px 12px;
        font-size: 13px;
      }
    }
  }
}

/* 1024分辨率以下进一步优化 */
@media screen and (max-width: 1024px) {
  .custom-select {
    .select-input {
      input {
        height: 40px;
        padding: 0 32px 0 10px;
        font-size: 12px;
      }
      
      .select-arrow {
        right: 10px;
        font-size: 10px;
      }
    }
    
    .select-options {
      max-height: 160px;
      
      li {
        padding: 8px 10px;
        font-size: 12px;
      }
    }
  }
}
</style>